<template>
	<div class="serviceNum">
		<!-- 社会责任队列 -->
		<div class="successList">
			<div style="min-height: 500px;">
				<!-- 队列 -->
				<div class="slist"  v-for="(item,index) in successArr" :key="index" style="cursor: pointer;" 
				@click="goNewsDetail(item,'社会责任','/socialResponsibility?index=2','social')">
					<!-- 左侧图片 -->
					<div class="leftImg">
						<img :src="item.logoUrl" width="200" height="200">
					</div>
					<!-- 右侧描述 -->
					<div class="rightDesc">
						<!-- 标题 -->
						<div class="descTitle">
							{{item.name}}
						</div>
						<!-- 简介 -->
						<div class="descInfo">
							<div>{{item.introduce}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 分页器 -->
			<div style="text-align: center;" class="py-4">
				<el-pagination background layout="prev, pager, next"
				@current-change="getSocial" :current-page="paging.currPage"
				:page-size="paging.everySize" :total="paging.allNum">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				successArr:[],
				paging: {currPage: 1, everySize: 10, allNum: 0},
			}
		},
		mounted() {
			this.getSocial()
		},
		methods: {
			getSocial(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				} 
				this.axios.get('/api/society/findAllByPage',{params:{
					currPage: vm.paging.currPage,
					everySize: vm.paging.everySize
				}}).then(res => {
					vm.successArr = res.data.data.societies
					vm.paging = res.data.data.pagingBean
				})
			},
			// 点击后前往新闻详情页
			goNewsDetail(item,mbx,mbxLink,newsType){
				if(item.reprintMark){
					window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/newsDetail',
					query:{
						id:item.id,
						mbx:mbx,
						mbxLink,
						newsType
					}
				})
				window.open(routeData.href, '_blank');
			},
		},
	}
</script>

<style scoped>
	.serviceNum{
		overflow: hidden;
	}
	.serviceNum .successTitle{
		font-size: 20px;
		font-weight: bold;
	}
	.serviceNum .successList{
		width: 1100px;
		min-height:500px;
		padding-top: 20px;
		margin: 0 auto;
	}
	.serviceNum .successList .slist{
		width: 1100px;
		height:200px;
		border: 1px solid #eee;
		margin-bottom:15px;
		display: flex;
	}
	.serviceNum .successList .slist .leftImg{
		width:200px;
		height:200px;
		background-color: #eee;
	}
	.serviceNum .successList .slist .rightDesc{
		margin-left: 20px;
		width: 850px;
		height: 90px;
		margin-top:20px;
	}
	.serviceNum .successList .slist .rightDesc .descTitle{
		color: #333;
		font-size: 16px;
		font-weight: bold;
	}
	.serviceNum .successList .slist .rightDesc .descInfo{
		padding-top:15px;
		font-size: 14px;
		color: #999;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>
